// React App entry point

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppContextProvider } from './context/AppContextProvider';
import ProtectedRoute from './components/ProtectedRoute';
import Devices from './screens/devices';
import Device from './screens/device';
import Leaderboards from './screens/leaderboards';
import Leaderboard from './screens/leaderboard';
import Leagues from './screens/leagues';
import League from './screens/league';
import Login from './screens/login';
import Logout from './screens/logout';
import Protocols from './screens/protocols';
import Protocol from './screens/protocol';
import Sessions from './screens/sessions';
import Session from './screens/session';
import Users from './screens/users';
import User from './screens/user';
import UserStatistics from './screens/userStatistics';
import App from './app';

const root = createRoot(document.getElementById('root'));

const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;

root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <AppContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ProtectedRoute><App/></ProtectedRoute>}>
            <Route index element={<Navigate to="/users" replace/>}/>
            <Route path="users" element={<Users/>}/>
            <Route path="users/:userId" element={<User/>}/>
            <Route path="users/:userId/statistics" element={<UserStatistics/>}/>
            <Route path="devices" element={<Devices/>}/>
            <Route path="devices/:deviceId" element={<Device/>}/>
            <Route path="leaderboards" element={<Leaderboards/>}/>
            <Route path="leaderboards/:leaderboardId" element={<Leaderboard/>}/>
            <Route path="leagues" element={<Leagues/>}/>
            <Route path="leagues/:leagueId" element={<League/>}/>
            <Route path="protocols" element={<Protocols/>}/>
            <Route path="protocols/:protocolId" element={<Protocol/>}/>
            <Route path="sessions" element={<Sessions/>}/>
            <Route path="sessions/:sessionId" element={<Session/>}/>
          </Route>
          <Route path="login" element={<Login />}/>
          <Route path="logout" element={<Logout />}/>
        </Routes>
      </BrowserRouter>
    </AppContextProvider>
  </GoogleOAuthProvider>
);
